import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const validateFundApprovalsFile = async ({
  file, isMultiStatusFileSelected,
}) => {
  let url = '/fiduciaries/funds/validate-file';
  if (isMultiStatusFileSelected) {
    url = '/fiduciaries/funds/validate-multistatus-file';
  }
  const options = {
    config: {
      headers: {
        'content-type': 'multipart/form-data',
      },
    },
  };

  const formData = new FormData();
  formData.append('file', file);

  return request.uploadFile(url, formData, options);
};

export const importFundApprovals = ({ payload }) => {
  // It seems pendingfiduciaryfunds and pending-fiduciary-funds are same
  const url = '/pendingfiduciaryfunds?strict_validation=true';
  return request.post(url, { data: JSON.stringify(payload) });
};
